module.exports = "/_next/static/images/american_express-306bc719fb4c9d8d5f28de19b0a3546e.svg";